import { useLocation } from 'react-router-dom-v5-compat';

const SIGNUP_ROUTE_PATTERNS = [/\/signup(\/|$)/, /\/register\//];

export const useIsSignupRoute = (): boolean => {
  const { pathname } = useLocation();
  return SIGNUP_ROUTE_PATTERNS.some((pattern) => pattern.test(pathname));
};
